module.exports = __webpack_public_path__ + "static/img/leftDownTwo.0f5dfe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/leftDownTwo.png
// module id = HMMf
// module chunks = 0